import { render, staticRenderFns } from "./AddOneToCart.vue?vue&type=template&id=ce83a0f8&scoped=true"
import script from "./AddOneToCart.vue?vue&type=script&lang=ts"
export * from "./AddOneToCart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce83a0f8",
  null
  
)

export default component.exports